<template>
    <div class="tooltip">
        <span class="tooltip-value">{{value}}</span>
    </div>
</template>

<script>
export default {
    props: ['value'],
    name: 'tooltip',
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .tooltip-trigger {
        position: relative;

        &:hover {

            .tooltip {
                display: block;
            }
        }
    }

    .tooltip {
        display: none;
        left: 50%;
        position: absolute;
        top: 0;
        transform: translate(-50%, 120%);

        &:before {
            background: $off-white;
            content: '';
            height: 10px;
            left: 50%;
            position: absolute;
            top: -5px;
            transform: translateX(-50%) rotate(45deg);
            width: 10px;
        }

        .tooltip-value {
            background: $off-white;
            border-radius: 4px;
            box-shadow: 0px 1px 3px 1px rgba(123,125,125,0.25);
            display: inline-block;
            padding: 4px 6px;
            font-size: .9em;
            white-space: nowrap;
        }
    }

    @media only screen and (min-width: $screen-xs) {

    }

</style>
